import React from "react";

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  width?: number;
  height?: number;
  fill?: boolean;
  style?: React.CSSProperties;
  alt?: string;
};

export function Image({ fill, style, alt, ...rest }: ImageProps) {
  const resolvedStyle = fill
    ? ({
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        ...style,
      } satisfies React.CSSProperties)
    : ({
        height: "auto",
        ...style,
      } satisfies React.CSSProperties);

  return <img alt={alt} loading="lazy" {...rest} style={resolvedStyle} />;
}

export default Image;
